import React from "react";
import dynamic from "next/dynamic";
import { RFPFormBlock } from "../index";

// Dynamic imports
import Section from "@/Components/LayoutComponents/Section";
import Image from "next/image";
const QuoteForm = dynamic(() => import("./QuoteForm"), {
  ssr: false,
});

interface RFPFormProps {
  data?: RFPFormBlock;
}

const RFPForm: React.FC<RFPFormProps> = ({ data }) => {
  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark py-[56px] lg:pb-[80px] xl:py-[120px] relative z-0">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>

          <div className="container">
            <div className="heading xl:mb-[40px] md:mb-[30px] mb-[24px]">
              <h2 className="text-heading-1 font-bold text-white text-center">
                Our Brands
              </h2>
              <p className="font-regular text-subtitle-3 text-gray-50  text-center">
                Trusted by Enterprises. Built for Growth.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:gap-[30px] md:gap-[24px] gap-[16px]">
              <div>
                <div className="w-full">
                  <Image
                    src="/images/brand/Troo-Inbound.png"
                    alt="Image tag"
                    width={389 * 2}
                    height={219 * 2}
                    quality={100}
                    className="w-full h-full"
                  />
                </div>
              </div>
              <div>
                <div className="w-full">
                  <Image
                    src="/images/brand/Quixom.png"
                    alt="Image tag"
                    width={389 * 2}
                    height={219 * 2}
                    quality={100}
                    className="w-full h-full"
                  />
                </div>
              </div>
              <div>
                <div className="w-full">
                  <Image
                    src="/images/brand/Troo-Themes.png"
                    alt="Image tag"
                    width={389 * 2}
                    height={219 * 2}
                    quality={100}
                    className="w-full h-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Section>
        <div className="container">
          <div className="max-w-[1230px] mx-auto text-center">
            <h2 className="text-heading-1 text-primary-text font-bold capitalize">
              {data?.title}
            </h2>
            <p className="text-subtitle-2 text-secondary-text font-regular mt-3 max-w-[1056px] mx-auto">
              {data?.sub_title}
            </p>
          </div>
          <div className="xl:mt-10 mt-8">
            <QuoteForm data={data} />
          </div>
        </div>
      </Section>
    </>
  );
};
export default RFPForm;
